up.compiler(".up_search_fresk", function (element) {
  const freskSelector = new Choices(element, {
    placeholder: true,
    placeholderValue: "Fresque / Atelier",
    removeItemButton: false,
    classNames: {
      containerOuter: ["choices", "w-80"],
      containerInner: [
        "choices__inner",
        "text-xs",
        "rounded-md",
        "border",
        "border-[#B3C1BA]",
        "bg-white",
        "px-1",
      ],
      input: ["choices__input"],
    },
  });

  element.addEventListener("change", (event) => {
    const slug = event.target.value;
    const baseUrl = element.dataset.url;
  
    up.navigate({
      url: `${baseUrl}/${slug}`,
      target: ".body",
    });
  });

  return () => {
    freskSelector.destroy();
  };
});
